const CHN = {
    "loginTitle": "登录",
    "mobileNumLabel": "手机号码",
    "passwordLabel": "密码",
    "loginButton": "登录",
    "forgotPasswordLink": "忘记密码?",
    "forgotPassword": "忘记密码",
    "forgotPasswordButton": "重置密码",
    "signupPrompt": "还不是会员吗",
    "navHome": "主页",
    "navLocation": "位置",
    "navProfile": "个人资料",
    "navInstaller": "安装人员",
    "navAbout": "关于",
    "verificationCodeLabel": "验证码（短信）",
    "nameLabel": "姓名或公司名称",
    "icNumLabel": "身份证号 (IC)",
    "emailLabel": "电子邮件地址",
    "retypePasswordLabel": "重新输入密码",
    "termsText": "*我同意<a href='#'>条款和条件</a>",
    "signupButton": "注册",
    "mobileNumPlaceholder": "请输入手机号码",
    "verificationCodePlaceholder": "请输入验证码",
    "namePlaceholder": "请输入姓名或公司名称",
    "icNumPlaceholder": "请输入身份证号",
    "emailPlaceholder": "请输入电子邮件地址",
    "otpButton": "请求 OTP",
    "faq1": "1. 如何将我的公司注册为安装人员？",
    "faq11": "点击右下角的“安装人员”，然后选择“申请”。申请成为安装人员后，请通知我们将您列入安装人员类别。",
    "faq2": "2. 安装人员的用途是什么？",
    "faq22": "安装人员部分旨在帮助用户找到合适的安装人员完成照明设备和配件的安装。",
    "faq3": "3. 如何评价安装人员？",
    "faq33": "前往“安装人员”（底部标签栏），选择您之前请求的安装人员，然后选择“评分和评论”以发表评论和评分。此选项仅在您从 AK Lighting 购买后才能使用。",
    "faq4": "4. 我可以使用自己的安装人员吗？",
    "faq44": "可以。请注意，未在我们应用程序中注册的安装人员无法在平台内被评分和评论。",
    "faq5": "5. 什么是收件箱？",
    "faq55": "当有促销活动时，您会自动收到通知。收到的消息将发送到收件箱。打开应用通知，以免错过促销期。",
    "faq6": "6. 我在哪里可以找到我的收据？",
    "faq66": "前往“个人资料”，点击右上角的“购买记录”以查看您的购买记录。",
    "faq7": "7. 我在哪里可以查看我的总积分？",
    "faq77": "前往“个人资料”，您会看到您的积分以及您的姓名、身份证号码和手机号。您还可以点击“编辑照片”更改您的个人资料图片。",
    "faq8": "8. 什么是积分？",
    "faq88": "注册成为 AK Lighting 会员后，您会立即获得 500 积分。每次购买后，您还会获得额外积分。",
    "notificationText": "通知",
    "helplineText": "帮助热线",
    "productsText": "产品",
    "aboutusText": "关于我们",
    "faqText": "常见问题",
    "languageText": "语言",
    "facebookText": "面子书",
    "logoutText": "登出",
    "about1": "A.K. Lighting 是 JUSTlight 创立的一家子公司。众所周知，由于 JUSTlight 展厅的停车位有限，进行库存清仓促销并不方便。",
    "about2": "因此，我们成立了一家新公司——A.K. Lighting。在 Canaan Square，这里有充足的免费停车位。您甚至可以直接进入我们的展厅。我们相信，这会为我们尊贵的客户带来更多便利。",
    "about3": "我们的清仓库存都是高价值商品。由于如今 LED 的价格不断贬值，我们仍有许多旧库存，因此我们对这些旧库存进行清仓，以便引入更多新产品。在这里，您可以找到价格便宜且实惠的灯具。",
    "about4": "我们还大量采购如 Philips 等知名品牌的商品，以便进行批量销售，让消费者受益。在这里，您可以找到适合公寓、廉价房、Airbnb 等各类住房的灯具。此外，我们还提供各种配件，方便改装灯具，也为承包商提供所需配件。未来，我们将引进更多配件以方便您的使用。",
    "about5": "在我们的应用程序中，我们允许用户获取最新的促销更新。我们还提供承包商的联系方式，您可以聘请他们进行灯具安装。A.K. Lighting 将照明解决方案带入生活。",
    "installerTitle": "安装人员",
    "applyButton": "申请",
    "detailsButton": "详细信息",
    "reviewButton": "评价",
    "mapLink": "查看地图",
    "addressText": "地址:",
    "openHours": "营业时间:",
    "dateText": "星期一至星期日 上午8:30 - 下午5:30",
    "contactText": "联系方式:",
    "installerApply": "安装申请",
    "applyTitle": "安装表格",
    "companyLabel": "公司名称",
    "contactLabel": "联系方式",
    "contactPlaceholder": "输入联系方式",
    "genderLabel": "性别",
    "genderChoice": "选择性别",
    "maleOption": "男",
    "femaleOption": "女",
    "raceLabel": "种族",
    "racePlaceholder": "输入种族",
    "experienceLabel": "经验年份",
    "experiencePlaceholder": "输入经验年份",
    "workerLabel": "员工人数",
    "workerPlaceholder": "输入员工人数",
    "specialtyLabel": "专长",
    "specialty1": "照明",
    "specialty2": "布线",
    "specialty3": "风扇",
    "specialty4": "项目",
    "otherLabel": "其他",
    "otherPlaceholder": "输入其他专长",
    "addressLabel": "地址",
    "addressPlaceholder": "输入地址",
    "submitButton": "提交",
    "invoiceLabel": "评价和评论发票编号",
    "invoiceSelect": "选择发票编号",
    "ratingLabel": "评分",
    "commentLabel": "评论",
    "commentPlaceholder": "输入评论",
    "uploadLabel": "上传照片",
    "closeButton": "关闭",
    "profileTitle": "个人资料",
    "mobileUpdate": "手机更新",
    "passwordUpdate": "密码更新",
    "referralList": "推荐列表",
    "deleteAccount": "关闭账户",
    "deleteText": "永久删除您的账户",
    "deleteTitle": "确认关闭账户？",
    "postDeletion": "我们将联系您的手机号码并要求提供一些删除账户的详细信息。 一旦一切确认无误，账户将在30天内排队删除。",
    "cancelDelete": "取消",
    "confirmDelete": "确认",
    "purchaseHistory": "购买历史",
    "editButton": "编辑",
    "editPhoto": "编辑照片",
    "memberName": "姓名：",
    "memberIc": "身份证号：",
    "memberMobile": "手机号：",
    "pointLabel": "总积分",
    "memberLabel": "会员自",
    "Are you sure you wnat to logout?": "您确定要注销吗？",
    "About Menu": "关于菜单",
    "OTP must be 6 digits": "OTP 必须是 6 位数字",
    "Password and Confirm Password not match": "密码和确认密码不匹配",
    "Invalid Login Credential": "无效的登录凭据",
    "no_internet": "服务器连接问题",
    "Login successfully!": "登录成功！",
    "Please Check terms and condition": "请检查条款和条件",
    "OTP not Valid": "OTP 无效",
    "termsText1": "*我同意",
    "termsText2": "条款和条件",
    "Promotion": "促销",
    "Category": "类别",
    "Ratings": "评分",
    "ContactNoTitle": "联系电话。",
    "Overall Rating": "总体评分",
    "(no rating)": "(无评分)",
    "Overall Rating (no rating)": "总体评分 (无评分)",
    "AK Lighting (Canaan Square Stutong)": "AK 照明 (Canaan Square Stutong)",
    "addressText1": "C2-G-4号 C 栋，第2厅，底楼，第4单元，迦南广场，Q403A，93350 古晋，砂拉越",
    "AK Lighting (Matang Metrocity)": "AK 照明 (Matang Metrocity)",
    "addressText2": "底楼，S/L 22&23，测量地段13768 第65节，KTLD，Metrocity，马当路，马当路，93050 古晋，砂拉越",
    "Description:": "描述：",
    "Old Password Required": "需要旧密码",
    "Password Required": "需要密码",
    "Confirm Password Required": "需要确认密码",
    "New Password": "新密码",
    "Confirm Password": "确认密码",
    "Copy Incoive ID": "复制发票 ID",
    "Invoice No:": "发票号：",
    "Subtotal:": "小计：",
    "Discount:": "折扣：",
    "Tax:": "税：",
    "View": "查看",
    "Invoice": "发票",
    "Id": "编号",
    "Name": "名称",
    "Price": "价格",
    "QTY": "数量",
    "Total": "总计",
    "Grand Total:": "总金额：",
    "otherOption": "其他",
    "Announcement": "公告",
    "Load More": "加载更多",
    "No more data to load": "没有更多数据可加载",
    "Data not found!": "未找到数据！",
    "PointsHistory": "积分历史",
    "Next_link_not_found": "未找到下一个链接！"
};
export default CHN;